/**
 * Step 3 — Dependentes.
 *
 * Todos entram marcados (spec §7): a decisão do titular é remover quem não vai
 * seguir, não escolher quem vai. A contagem no topo sai daqui, e a retenção
 * realimenta o total do Step 2 e o resumo do Step 5 — então a chave usada é
 * sempre o CPF que veio no `resolve`, nunca um CPF corrigido na edição inline,
 * que o backend não reconheceria.
 *
 * Zero dependentes é um caso válido: o titular segue sozinho.
 */

import { Alert } from "@mui/material";

import { DependentCard } from "../components/DependentCard";
import { StepActions } from "../components/StepActions";
import { useExtensionForm } from "../context";
import { Caption, Header, Paragraph, Stack } from "../styled";
import { IDependentEdit } from "../types";

export function Step3Dependents() {
  const { data, state, updateState, goNext, goBack } = useExtensionForm();
  const { dependents } = data;

  const retained = state.retainedDependentTaxPayerIds;

  function toggleRetained(taxPayerId: string) {
    const isRetained = retained.includes(taxPayerId);

    updateState({
      retainedDependentTaxPayerIds: isRetained
        ? retained.filter((id) => id !== taxPayerId)
        : [...retained, taxPayerId],
    });
  }

  function saveEdit(taxPayerId: string, edit: IDependentEdit) {
    updateState({
      dependentEdits: { ...state.dependentEdits, [taxPayerId]: edit },
    });
  }

  return (
    <Stack $gap="24px">
      <Stack $gap="4px">
        <Header>Dependentes</Header>
        <Paragraph>
          {dependents.length === 0
            ? "Não encontramos dependentes vinculados ao seu plano."
            : "Selecione quem manter e edite os dados se necessário."}
        </Paragraph>
      </Stack>

      {dependents.length > 0 && (
        <Caption>
          {retained.length} de {dependents.length}{" "}
          {dependents.length === 1
            ? "dependente selecionado"
            : "dependentes selecionados"}
        </Caption>
      )}

      <Stack $gap="12px">
        {dependents.map((dependent) => (
          <DependentCard
            key={dependent.taxPayerId}
            dependent={dependent}
            isRetained={retained.includes(dependent.taxPayerId)}
            edit={state.dependentEdits[dependent.taxPayerId]}
            onToggleRetained={() => toggleRetained(dependent.taxPayerId)}
            onSaveEdit={(edit) => saveEdit(dependent.taxPayerId, edit)}
          />
        ))}
      </Stack>

      {dependents.length > 0 && retained.length === 0 && (
        <Alert severity="warning">
          Nenhum dependente será mantido. Você seguirá apenas com o titular no
          plano.
        </Alert>
      )}

      <StepActions
        nextLabel="Próximo: Documentos →"
        onNext={goNext}
        onBack={goBack}
      />
    </Stack>
  );
}
